import PickerIcon from "@assets/tsx/icon/pickerIcon";
import React from "react";
import { Link } from '@ambiguous/link';
export default function Button({ title, url, url__props, color, icon, rounded, tooltip, shadow, target, pickericon, chevron, block, chevronDir }) {
    let roundedClassName = '';
    if (rounded == 'yes' && !title) {
        roundedClassName = ' btn-circle';
    }
    else if (rounded == 'yes') {
        roundedClassName = ' btn-pill';
    }
    return (React.createElement(Link, { href: url, className: `btn ${color ? `btn-${color}` : ''}${roundedClassName}${chevron === 'yes' ? ' btn--has-chevron' : ''}${icon || pickericon ? ' btn--has-icon' : ''}${shadow === 'yes' ? ' btn--shadow' : ''}${block === 'yes' ? ' btn-block' : ''}`, title: tooltip, target: (url__props === null || url__props === void 0 ? void 0 : url__props.blank) ? '_blank' : null, rel: (url__props === null || url__props === void 0 ? void 0 : url__props.blank) ? 'noreferrer noopener' : null, download: (url__props === null || url__props === void 0 ? void 0 : url__props.type) === 'file' ? true : null },
        React.createElement(ButtonIcon, { icon: icon }),
        React.createElement("span", { className: "btn-title" }, title),
        chevron === 'yes' && (React.createElement("span", { className: "btn-chevron" },
            React.createElement("i", { className: `fas fa-chevron-${chevronDir || 'right'}` })))));
}
function ButtonIcon({ icon }) {
    if (!icon)
        return null;
    let final_icon = icon;
    if (final_icon.value) {
        const value_split = final_icon.value.split(' ');
        const convert_icon = {
            iconClassName: value_split[1],
            iconName: value_split[1].substring(3),
            iconPack: 'fontawesome',
            iconPackType: 'fontawesome',
            iconPrefix: value_split[0]
        };
        final_icon = convert_icon;
    }
    return React.createElement("span", { className: "btn-icon" },
        React.createElement(PickerIcon, Object.assign({}, final_icon)));
}
